    document.addEventListener("DOMContentLoaded", function () {
        const articlesWrapper   = document.querySelector(".articles");
        const paginationWrapper = document.querySelector(".pagination");
        const loader            = document.createElement("div");
        loader.className        = "loader";

        const loaderImage = document.createElement("img");
        loaderImage.src = "/images/spinner.gif";
        loader.appendChild(loaderImage);
        paginationWrapper.appendChild(loader);

        let currentPage = 1;
        if (currentPage > 1) {
            window.history.replaceState(null, '', window.location.pathname + '?page=' + currentPage);
        } else {
            const url = new URL(window.location.href);
            url.searchParams.delete('page');
            window.history.replaceState(null, '', url.pathname + url.search);
        }

        function createArticleCard(article) {
            const card       = document.createElement("div");
            const imgWrapper = document.createElement("div");
            const imgLink    = document.createElement("a");
            const img        = document.createElement("img");
            const titleDiv   = document.createElement("div");
            const title      = document.createElement("span");
            const titleLink  = document.createElement("a");
            const btnLink    = document.createElement("a");

            card.className       = "articles__card";
            imgWrapper.className = "articles__img-wrapper";

            imgLink.href         = `/articles/${article.slug}`;
            img.className        = "articles__card-img";
            img.src              = article.image || "/images/icons/logo.png";
            img.alt              = "Постер";

            titleDiv.className   = "articles__card-title";
            title.classList.add('uppercase','text-lg');
            titleLink.href       = `/articles/${article.slug}`;
            titleLink.textContent= article.title;

            btnLink.href         = `/articles/${article.slug}`;
            btnLink.className    = "articles__card-btn";
            btnLink.textContent  = "Подробнее";

            imgLink.appendChild(img);
            imgWrapper.appendChild(imgLink);
            card.appendChild(imgWrapper);

            title.appendChild(titleLink);
            titleDiv.appendChild(title);
            card.appendChild(titleDiv);
            card.appendChild(btnLink);

            articlesWrapper.appendChild(card);
        }

        function createPagination(data) {
            paginationWrapper.innerHTML = "";

            const totalPages = data.meta.last_page;

            const prevButton = document.createElement("button");
            prevButton.textContent = "Назад";
            prevButton.classList.add('pagination-button')

            prevButton.onclick = function () {
                if (currentPage > 1) {
                    currentPage--;
                    loadArticles();
                }
            };
            paginationWrapper.appendChild(prevButton);

            const range = 2;

            let startPage = Math.max(1, currentPage - range);
            let endPage = Math.min(totalPages, currentPage + range);

            if (startPage > 1) {
                const pageButton = document.createElement("button");
                pageButton.textContent = "1";
                pageButton.classList.add('pagination-button')

                pageButton.onclick = function () {
                    currentPage = 1;
                    loadArticles();
                };
                paginationWrapper.appendChild(pageButton);

                if (startPage > 2) {
                    const ellipsis = document.createElement("span");
                    ellipsis.textContent = "  ...  ";
                    paginationWrapper.appendChild(ellipsis);
                }
            }

            for (let page = startPage; page <= endPage; page++) {
                const pageButton = document.createElement("button");
                pageButton.classList.add('pagination-button')
                pageButton.textContent = page;

                if (page === currentPage) {
                    pageButton.classList.add('pagination-button-current');
                    pageButton.disabled = true;
                }

                pageButton.onclick = function () {
                    currentPage = page;
                    loadArticles();
                };

                paginationWrapper.appendChild(pageButton);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    const ellipsis = document.createElement("span");
                    ellipsis.textContent = "...";
                    paginationWrapper.appendChild(ellipsis);
                }

                const pageButton = document.createElement("button");
                pageButton.classList.add('pagination-button')



                pageButton.textContent = totalPages;
                pageButton.onclick = function () {
                    currentPage = totalPages;
                    loadArticles();
                };
                paginationWrapper.appendChild(pageButton);
            }

            const nextButton = document.createElement("button");
            nextButton.textContent = "Вперед";
            nextButton.classList.add('pagination-button')

            nextButton.onclick = function () {
                if (currentPage < totalPages) {
                    currentPage++;
                    loadArticles();
                }
            };
            paginationWrapper.appendChild(nextButton);
        }

        function updateCanonical() {
            let canonical = document.querySelector("link[rel='canonical']");

            if (!canonical && currentPage > 1) {
                canonical = document.createElement('link');
                canonical.setAttribute('rel', 'canonical');
                document.head.appendChild(canonical);
            }
            if(currentPage > 1) {
                canonical.setAttribute('href', window.location.origin + window.location.pathname);
            } else if(canonical) {
                canonical.remove()
            }
        }

        function updateTitle() {
            const baseTitle = "Блог";
            if (currentPage > 1) {
                document.title = `${baseTitle} | Страница №${currentPage}`;
            } else {
                document.title = baseTitle;
            }
        }

        function loadArticles() {
            if(currentPage > 1) {
                window.history.replaceState(null, '', window.location.pathname + '?page=' + currentPage);
            } else {
                const url = new URL(window.location.href);
                url.searchParams.delete('page');
                window.history.replaceState(null, '', url.pathname + url.search);
            }

            updateCanonical(); // Обновляем canonical тег при изменении страницы
            updateTitle();
            loader.style.display = "block";
            fetch(`/api/articles?page=${currentPage}`)
                .then((response) => response.json())
                .then((data) => {
                    articlesWrapper.innerHTML = "";
                    data.data.forEach((article) => {
                        createArticleCard(article);
                    });
                    createPagination(data);
                    loader.style.display = "none";
                })
                .catch((error) => {
                    console.error("Ошибка при загрузке данных:", error);
                    loader.style.display = "none";
                });
        }

        loadArticles();
    });
